/**
 * 生成随机的密钥
 * created on 2018/6/20
*/
import crypto from 'crypto'
import {SECRET_KEY_MD5} from '@/config/constant'

class Md5 {
    static genMd5 () {
        let md5 = crypto.createHash('md5')
        let timeStamp = Md5.genTimeStamp()
        let randomCode = Md5.genRandomSelect(6)
        let key = new Buffer(SECRET_KEY_MD5, 'base64').toString()
        let str = `${timeStamp}|${randomCode}|${key}`
        md5.update(str)
        let salt = md5.digest('hex')
        return `${salt}${randomCode}${timeStamp}`
    }
    static genRandomSelect (n) {
        let STRING_SELECT = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890'
        let str = '', i = 0, len = STRING_SELECT.length
        for (; i < n; i++) {
            str += STRING_SELECT[Math.floor(Math.random() * len)]
        }
        return str
    }
    static genTimeStamp () {
        let systemDeltaTime = Number(sessionStorage.getItem('systemDeltaTime') || 0)
        let userMachineTime = Date.now()
        return userMachineTime + systemDeltaTime
    }
    static updateSystemDeltaTime (timestamp) {
        let systemTime = Number(timestamp)
        let userTime = Date.now()
        sessionStorage.setItem('systemDeltaTime', (systemTime - userTime))
    }
}

export function aesEncrypt(data, key) {
    const cipher = crypto.createCipher('aes192', key);
    var crypted = cipher.update(data, 'utf8', 'hex');
    crypted += cipher.final('hex');
    return crypted;
}

export function aesDecrypt(encrypted, key) {
    const decipher = crypto.createDecipher('aes192', key);
    var decrypted = decipher.update(encrypted, 'hex', 'utf8');
    decrypted += decipher.final('utf8');
    return decrypted;
}

export default Md5
